<template>
  <div
    :style="{ borderColor: `rgba(96,71,18,0.4)` }"
    @contextmenu.prevent="blockRightButton"
    class="wrapper"
  >
    <comp-header
      :close-callback="closeCallback"
      @close="closeReport"
      @feedback="feedbackReport"
      @clickExchange="clickExchange"
      @emitInvoicing="clickInvoicing"
      show-haohuo
      hide-invoice
      hide-exchange
    />
    <user-info
      @showPay="showPayFn"
      @showChangeUserInfoPop="showChangeUserInfoPop"
      @toRank="report({ click: 53 })"
    />
    <div
      :style="{ height: wrapHeight }"
      @scroll="handleScroll"
      class="wrap_scroll"
    >
      <slot />
    </div>

    <!-- 修改用户信息弹窗 -->
    <ChangeUserInfoPop
      v-if="isChangeUserInfoPop"
      v-model="isChangeUserInfoPop"
      :tab-active-id="tabActiveValue"
    />

    <!-- 终身会员挽留 -->
    <LifelongVipDiscount @paySuccess="paySuccess" />

    <!-- 兑换会员弹框 -->
    <ExchangeVipPop v-model="exchangeVipPopVisible" />

    <RetainUsers />
  </div>
</template>
<script>
import UserInfo from '@/components/userInfo/UserInfo.vue'
import CompHeader from '@/layout/Header.vue'
import HomeTab from '@/components/HomeTab'
import LifelongVipDiscount from '@/components/sendCoupon/activity/LifelongVipDiscount.vue'
import RetainUsers from '@/components/sendCoupon/activity/RetainUsers.vue'
import ChangeUserInfoPop from '@/components/userInfo/ChangeUserInfoPop'
import ExchangeVipPop from '@/components/enterprise/ExchangeVipPop.vue'

import { mapGetters, mapActions } from 'vuex'
import client from '@/client/'
import { STAY_PAGE_NUM, LOCALSTORAGE_POSITION_KEY, LOCALSTORAGE_PAY_HEIGHT_KEY, LOGIN_SERVICE } from '@/config/dataMap'
import { scrollTo } from '@/utils/scroll'
import { PopupController } from '@/services/act/PopupController'
import common from '@/client/modules/common.js'
import { getActConfig } from '@/api/act.js'
import electronTicket from '@/client/modules/electronTicket.js'
import { cnterpriseState } from '@/components/enterprise/enterprise.service'

import Cookie from 'js-cookie'

export default {
  name: 'PdfHomeHeader',
  components: {
    UserInfo,
    CompHeader,
    ChangeUserInfoPop,
    HomeTab,
    LifelongVipDiscount,
    RetainUsers,
    ExchangeVipPop
  },
  data () {
    return {
      wrapHeight: '620px',
      isChangeUserInfoPop: false,
      tidList: [],
      exchangeVipPopVisible: false,
      tabActiveValue: 0
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'loginStatus',
      'openId',
      'token',
      'continuousInfo'
    ]),
  },

  watch: {
    continuousInfo (info) {
      // 签约状态 && 存在下次续费时间 && 路由参数continuous存在并且值为1
      if (info.continuous_status === 2 && info.next_deduction_time && this.isShowContinuous(this.$route.query.continuous)) {
        this.handleNoticeAction()
        // 去掉路由参数，避免退出重新登录会二次触发弹框
        this.$router.replace({
          query: { ...this.$route.query, continuous: 0 }
        })
      }
    }
  },

  mounted () {
    this.reportQuitRetainUsers({ showed: 1 })
    this.getHasEnterpriseVip()
  },
  methods: {
    ...mapActions('user', ['refresh']),
    // 屏蔽右键
    blockRightButton () {
      return false
    },

    // 是否展示续费通知弹窗
    isShowContinuous (continuous) {
      return Number(continuous || 0) === 1
    },

    // 打开续费通知
    handleNoticeAction () {
      // 消息盒子的action暂时只有打开续费信息窗口
      this.openUserInfoPop()
      this.tabActiveValue = 3
      electronTicket.REPORT.reportElectronicInvoiceClickandShow({ source: 3 })
    },

    /** 点击兑换会员 */
    clickExchange () {
      client.enterprise.REPORT.reportRedeemCodeKfmt({ step: 1 })

      if (!this.loginStatus) {
        client.common.API.userLogin({ url: LOGIN_SERVICE.url })
        return
      }

      this.exchangeVipPopVisible = true
      client.enterprise.REPORT.reportRedeemCodeKfmt({ step: 2 })
    },

    /** 获取配置是否展示企业会员 */
    async getHasEnterpriseVip () {
      const res = await getActConfig({ type: 'has_pdf_enterprise_tab' })
      const tryno = Cookie.get('tryno') || ''
      const { tid1_list = [], phone = '', qr_code = '' } = res?.has_pdf_enterprise_tab[tryno] || {}

      this.tidList = tid1_list
      cnterpriseState.phone = phone
      cnterpriseState.qr_code = qr_code
    },

    async closeCallback () {
      const isLogin = this.loginStatus ? 1 : 2
      this.reportQuitRetainUsers({ login_type: isLogin, openid: this.openId || 0 })

      const needKeepWindow = await PopupController.getIns().executePopup(this)
      if (needKeepWindow) {
        return
      }

      this.closeReport()
      this.reportQuitRetainUsers({ clicked: 1 })

      window.close()
    },
    paySuccess () {
      this.refresh({
        token: this.token,
        open_id: this.openId,
        webRefresh: 1,
      })
    },
    closeReport () {
      client.home.REPORT.reportCenterStayTimeKfmt({
        show_page: STAY_PAGE_NUM[this.$route.name],
        user_login: this.loginStatus ? 1 : 2
      })
      // 清除滚动条位置
      this.clearScrollPosition()
    },
    feedbackReport () {
      let id
      if (this.loginStatus) {
        if (this.isMember) {
          id = 29
        } else {
          id = 36
        }
      } else {
        id = 35
      }

      this.report({ click: id })
    },
    showPayFn () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    },
    clearScrollPosition () {
      localStorage.removeItem(LOCALSTORAGE_POSITION_KEY)
      localStorage.removeItem(LOCALSTORAGE_PAY_HEIGHT_KEY)
    },
    reportQuitRetainUsers ({ showed = 0, clicked = 0, openid = 0, login_type = 0 }) {
      client.retainUsers.REPORT.reportQuitRetainUsers({ showed, clicked, openid, login_type })
    },
    report ({
      click = 0,
      hover = 0,
      sub_mode = (this.$refs.payModule &&
        this.$refs.payModule.sub_mode) ||
        0
    }) {
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        user_login: this.loginStatus ? 1 : 2
      })
    },
    scrollToPay () {
      this.$router.push('/')
      const className = 'new-pay'
      const _dom = document.querySelector(`.${className}`)
      if (!_dom) {
        return
      }
      const scrollTop = _dom.offsetTop
      const _parent = document.querySelector('.wrap_scroll')
      scrollTo(scrollTop, 0, _parent)
    },

    showChangeUserInfoPop () {
      this.openUserInfoPop()
      this.tabActiveValue = 0
      electronTicket.REPORT.reportElectronicInvoiceClickandShow({ source: 2 })
    },

    /** 开具发票 */
    clickInvoicing () {
      if (!this.loginStatus) {
        client.common.API.userLogin({ url: LOGIN_SERVICE.url })
        return
      }
      electronTicket.REPORT.reportElectronicInvoiceClickandShow({ source: 1 })
      this.openUserInfoPop()
      this.tabActiveValue = 2
    },

    openUserInfoPop () {
      this.isChangeUserInfoPop = true
    },

    // 处理页面滚动事件
    handleScroll () {
      window.app.$EventBus.$emit('handleScrollEvent', event)
    }
  }
}
</script>
<style lang="scss">
::selection {
  background: transparent;
}
.wrapper {
  position: relative;
  width: 702px;
  height: 742px;
  margin: 0 auto;
  border: 1px solid rgba(21, 161, 225, 0.4);
  box-sizing: border-box;
}

.noScroll {
  overflow-y: hidden;
}
.wrap_scroll {
  position: relative;
  background: #fff;
  overflow-x: hidden;
  overflow-y: overlay;
  width: 100%;
}
</style>
